import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form, Select, Tag, Typography } from 'antd';
import React, { useMemo } from 'react';

import type { NSendoutsApi } from '@app/services/rtkQuery/Sendouts/types';
import { getContrastYIQ } from '@app/utils';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import type { SelectProps } from 'antd';
import type { FC, ReactElement } from 'react';
import '@features/SendoutCreationModal/components/SendMessageModal/styles/TagSelect.desktop.scss';
interface Props {
  prepareSendoutCreation: NSendoutsApi.PrepareSendoutCreationResponse | null;
}
const { Text } = Typography;
const { useFormInstance } = Form;

export const TagSelect: FC<Props> = ({ prepareSendoutCreation }) => {
  const form = useFormInstance();

  const tags = useMemo(() => {
    const options = prepareSendoutCreation?.Tags
      ? prepareSendoutCreation.Tags.map(({ Id, Name, IconId, Color }) => ({
          label: (
            <Tag
              key={IconId}
              icon={
                <FontAwesomeIcon
                  className="tag-icon"
                  icon={IconId as IconProp}
                  style={{
                    color: getContrastYIQ(Color),
                  }}
                />
              }
              color={Color || 'white'}
            >
              <Text style={{ color: getContrastYIQ(Color) }}>{Name}</Text>
            </Tag>
          ),
          value: Id,
          name: Name,
          color: Color || 'white',
        }))
      : [];
    return options;
  }, [prepareSendoutCreation]);

  const onChange = (value: number[]) => {
    form.setFieldsValue({ tags: value });
  };

  const tagRender: SelectProps['tagRender'] = (props) => {
    const { label, closable, onClose } = props;
    const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
      event.preventDefault();
      event.stopPropagation();
    };
    const color = (label as ReactElement)?.props?.color || 'white';
    return (
      <Tag
        color={color}
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
        className="tag-wrapper"
      >
        {label}
      </Tag>
    );
  };

  return (
    <Form.Item
      name="tags"
      colon
      layout="horizontal"
      label={<Text>Присвоить тег после отправки:</Text>}
    >
      <Select
        optionFilterProp="name"
        className="sendout-tag-select"
        mode="multiple"
        size="middle"
        placeholder="Выберите тег"
        options={tags}
        style={{ height: 'auto' }}
        onChange={onChange}
        tagRender={tagRender}
      />
    </Form.Item>
  );
};
